import React from 'react';
import { Container, Grid, Header, Image } from 'semantic-ui-react';

import UserAvatar from '../components/UserAvatar';

import '../styles/TeamCard.css';

const TeamCard = props => {
  const { team, onClick } = props;

  return (
    <Container as="a" onClick={onClick} className="TeamCard">
      <Grid stretched padded columns="2">
        <Grid.Column textAlign="left" verticalAlign="middle" width={6}>
          <Header>
            <Image rounded src={team.logo_url} />
            <Header.Content>{team.name}</Header.Content>
          </Header>
        </Grid.Column>
        <Grid.Column textAlign="right" width={6}>
          {team.users && (
            <Container className="TeamCard__Members">
              {team.users
                .slice(0, Math.max(team.users.length, 10))
                .map(user => (
                  <UserAvatar stretched key={user.id} user={user} />
                ))}
            </Container>
          )}
        </Grid.Column>
      </Grid>
    </Container>
  );
};

export default TeamCard;



// WEBPACK FOOTER //
// ./src/components/TeamCard.js